<app-navbar></app-navbar>

<!-- Page Banner -->
<div class="rs-page-banner">
  <div class="rs-pb-deco">
    <div class="rs-pb-dots"></div>
    <div class="rs-pb-circle rs-pb-c1"></div>
    <div class="rs-pb-circle rs-pb-c2"></div>
  </div>
  <div class="container">
    <div class="rs-pb-content">
      <h1 class="rs-pb-title">Notice Board</h1>
      <nav class="rs-pb-breadcrumb">
        <a routerLink="/">Home</a>
        <i class="ri-arrow-right-s-line"></i>
        <span>Notice Board</span>
      </nav>
    </div>
  </div>
</div>

<!-- Content -->
<div class="rs-inner-page" style="font-family:'SolaimanLipi_bold','Ubuntu',sans-serif;font-size:87%;">
  <div class="container">
    <div class="row g-4 align-items-start">

      <!-- Left: Notice List -->
      <div class="col-lg-8 col-md-12">
        <div class="rs-notice-header">
          <h4><i class="ri-notification-3-line" style="color:#d3363a;margin-right:8px;"></i>Notices &amp; Circulars</h4>
          <div class="rs-notice-dropdown">
            <button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="ri-filter-3-line" style="margin-right:5px;"></i>{{ selectedCategory }}
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li><button class="dropdown-item" type="button" (click)="onSelectCategory('All Notices')">All Notices</button></li>
              <ng-container *ngFor="let item of notice_cat_values">
                <li><button class="dropdown-item" type="button" (click)="onSelectCategory(item)">{{ item }}</button></li>
              </ng-container>
            </ul>
          </div>
        </div>

        <div class="rs-notice-list">
          <div class="rs-notice-item wow fadeInUp" *ngFor="let data of filteredNotices" [attr.data-wow-delay]="'0.1s'">
            <div class="rs-notice-date-box">
              <span class="rs-nd-day">{{ data.CreatedDate | date:'dd' }}</span>
              <span class="rs-nd-mon">{{ data.CreatedDate | date:'MMM' }}</span>
            </div>
            <div class="rs-notice-body">
              <a class="rs-notice-title" [href]="data.FileLink" target="_blank">{{ data.EnglishTitle }}</a>
              <div class="rs-notice-meta">
                <i class="ri-eye-line"></i> {{ data.TotalHitCount }} views &nbsp;|&nbsp;
                <i class="ri-price-tag-3-line"></i> {{ data.NoticeCategoryName }}
              </div>
            </div>
            <a [href]="data.FileLink" target="_blank" class="rs-notice-dl">
              <i class="ri-download-cloud-2-line"></i>
              Download
            </a>
          </div>
          <div *ngIf="!filteredNotices?.length" class="rs-empty-state">
            <i class="ri-notification-off-line"></i>
            <h4>No notices found</h4>
          </div>
        </div>
      </div>

      <!-- Right: Aside -->
      <div class="col-lg-4 col-md-12">
        <app-aside></app-aside>
      </div>

    </div>
  </div>
</div>
